import { IcArrow } from '@assets/icons/24x24';
import { Button, HStack, Icon, Separator, Text, VStack } from '@chakra-ui/react';
import { StatusFilter } from '@components/cockpit/panels/monitoring/filters/StatusFilter';
import ToggleButtonGrid from '@components/common/inputs/buttons/ToggleButtonGrid';
import { ScrollArea } from '@components/ui/ScrollArea';
import { CategoryEnum } from '@utils/sensors/configuration.constants';
import { FormattedMessage, useIntl } from 'react-intl';

import { MonitoringSensorType } from '../monitoring.types';
import { useMonitoringContext } from '../MonitoringContext';
import CategoryFilter from './CategoryFilter';
import ComplexityFilter from './ComplexityFilter';
import FamilyFilter from './FamilyFilter';

export default function Filters() {
  const { formatMessage } = useIntl();
  const { state, setOpen, numberOfChanges, toggleMonitoringType, reset } = useMonitoringContext();
  const canReset = numberOfChanges > 0;
  if (!state.open) {
    return null;
  }

  const buttonsMap = new Map<CategoryEnum, Map<MonitoringSensorType, boolean>>(
    Array.from(state.categories.keys()).map((category: CategoryEnum) => {
      switch (category) {
        case CategoryEnum.LAD: {
          return [category, state.ladTypes];
        }
        case CategoryEnum.PERIM: {
          return [category, state.perimTypes];
        }
      }
    }),
  );

  return (
    <VStack
      gap={0.25}
      width="402px"
      backgroundColor="neutral.black"
      borderRight="2px solid"
      borderColor="neutral.black"
      height="100%"
      flexShrink={0}
    >
      <HStack
        justifyContent="space-between"
        paddingX={2}
        height="56px"
        backgroundColor="neutral.850"
        width="100%"
        flexShrink={0}
      >
        <Button variant="toggle" size="toggleS" data-active={canReset} disabled={!canReset} onClick={reset}>
          <Text>
            <FormattedMessage id="components.notificationSearch.filters.reset" />
          </Text>
        </Button>
        <Icon
          as={IcArrow}
          boxSize="24px"
          transform="rotate(180deg)"
          color="neutral.300"
          cursor="pointer"
          _hover={{ color: 'skyBlue' }}
          onClick={() => setOpen(false)}
        />
      </HStack>
      <ScrollArea>
        <VStack
          gap={0}
          height="100%"
          width="100%"
          flex={1}
          separator={<Separator size="md" borderColor="neutral.900" />}
          backgroundColor="neutral.850"
        >
          <CategoryFilter />
          <FamilyFilter />
          <ToggleButtonGrid
            label={formatMessage({ id: 'components.monitoring.filter.types' })}
            buttons={buttonsMap}
            onClick={(_, label) => toggleMonitoringType(label)}
          />
          <StatusFilter />
          <ComplexityFilter />
        </VStack>
      </ScrollArea>
    </VStack>
  );
}
